import { useState } from "react";
import { LuMenu } from "react-icons/lu";
import LogoBlack from "../../../assets/logo/logo-black.svg?react";
import LogoWhite from "../../../assets/logo/logo-white.svg?react";
import { useIsUserSignedIn, useIsAuthInitialized } from "../../../core_stores/useAuthStore";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";
import { useAuthModal } from "../../../providers/AuthModalProvid";
import { useSubscriptionsModal } from "../../../providers/SubscriptionsModalProvider";
import { useTheme } from "../../../providers/ThemeProvider";
import { WelcomeGuestMenu } from "./WelcomeGuestMenu";

export function WelcomeAppBar() {
  const isUserSignedIn = useIsUserSignedIn();
  const isAuthInitialized = useIsAuthInitialized();
  const isCompactView = useIsCompactView();
  const { theme } = useTheme();
  const [isGuestMenuOpen, setIsGuestMenuOpen] = useState(false);

  const { show: showAuthModal } = useAuthModal();

  async function onAuth() {
    await showAuthModal();
  }

  const Logo = theme === "dark" ? LogoWhite : LogoBlack;

  return (
    <div
      className={`${
        isCompactView ? "p-4" : "py-6 px-8"
      } z-30 w-full flex flex-row items-center justify-between`}
    >
      <a href="/" className="cursor-pointer">
        <Logo
          className={`${
            isCompactView ? "h-[26px] w-[126px]" : "h-[32px] w-[156px]"
          } z-20`}
        />
      </a>

      <div className="flex items-center gap-3">
        {/* Hide Discover apps on mobile (guests have it in hamburger menu, logged-in users have it in sidebar) */}
        {!isCompactView && <AppStoreRankingsBtn />}
        {!isCompactView && <PricingBtn />}
        {isAuthInitialized && !isUserSignedIn ? (
          isCompactView ? (
            <>
              <GetStartedBtn onGetStarted={onAuth} />
              <div className="relative">
                <LuMenu
                  size={28}
                  onClick={() => setIsGuestMenuOpen(!isGuestMenuOpen)}
                  className="cursor-pointer text-dark-text"
                />
                <WelcomeGuestMenu
                  isOpen={isGuestMenuOpen}
                  onClose={() => setIsGuestMenuOpen(false)}
                />
              </div>
            </>
          ) : (
            <SignInSignUpBtn onSignIn={onAuth} onSignUp={onAuth} />
          )
        ) : null}
      </div>
    </div>
  );
}

function GetStartedBtn({ onGetStarted }: { onGetStarted?: () => void }) {
  return (
    <button
      id="home-get-started"
      onClick={onGetStarted}
      className="bg-primary-blue text-white font-semibold px-4 py-2 flex items-center justify-center gap-2 rounded-full focus:outline-none hover:opacity-90 transition-opacity duration-300 text-sm"
    >
      Get started
    </button>
  );
}

function SignInSignUpBtn({
  onSignIn,
  onSignUp,
}: {
  onSignIn?: () => void;
  onSignUp?: () => void;
}) {
  return (
    <div className="flex items-center gap-2">
      <button
        id="home-sign-in"
        onClick={onSignIn}
        className="text-light-text dark:text-dark-text font-medium px-4 h-[36px] flex items-center justify-center rounded-full focus:outline-none hover:bg-light-hover dark:hover:bg-dark-hover transition-colors text-sm"
      >
        Sign in
      </button>
      <button
        id="home-sign-up"
        onClick={onSignUp}
        className="bg-primary-blue text-white font-semibold px-4 py-2 flex items-center justify-center gap-2 rounded-full focus:outline-none hover:opacity-90 transition-opacity duration-300 text-sm"
      >
        Get started
      </button>
    </div>
  );
}

function PricingBtn() {
  const { open: openSubscriptionsModal } = useSubscriptionsModal();

  return (
    <button
      id="home-pricing"
      onClick={openSubscriptionsModal}
      className="text-light-text dark:text-dark-text font-medium px-4 h-[36px] flex items-center justify-center rounded-full focus:outline-none hover:bg-light-hover dark:hover:bg-dark-hover transition-colors text-sm"
    >
      Pricing
    </button>
  );
}

function AppStoreRankingsBtn() {
  return (
    <a
      href="/app-store-rankings"
      className="text-light-text dark:text-dark-text font-medium px-4 h-[36px] flex items-center justify-center rounded-full focus:outline-none hover:bg-light-hover dark:hover:bg-dark-hover transition-colors text-sm"
    >
      Discover apps
    </a>
  );
}
